export const API_BASE_URL = 'https://cleaningmiamipanel.org/api'

export const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
});

export const authFetch = (url, options = {}) =>
    fetch(url, {
        ...options, 
        headers: {
            ...authHeaders(),
            ...options.headers
        }
    }).then(res => {
        if (res.status === 401) {
            if (window.handleUnauthorized) window.handleUnauthorized();
            return;
        }
        return res.json();
    });